import React, { useState, useEffect } from 'react';
import { SpeedTestArea, Sidebar } from '../../components/home/speedtest/index.js';
import { useSpeedTest } from '../../components/home/speedtest/useSpeedTest.js';
import { useDarkMode } from '../../components/darkmode/DarkModeContext';
import Footer from '../../components/footer/index';

const SpeedTestPage = () => {
  const { isDarkMode } = useDarkMode(); // Panggil hook useDarkMode
  
  const {
    isActive,
    currentPhase,
    results,
    testHistory,
    currentSpeed,
    progress,
    simulateSpeedTest,
    resetTest
  } = useSpeedTest();

  const [serverInfo, setServerInfo] = useState({
    location: 'Detecting...',
    provider: 'Loading...',
    ip: 'Detecting...'
  });
  
  const [showHistory, setShowHistory] = useState(false);

  const handleStartTest = () => {
    // Start the test
    simulateSpeedTest(serverInfo);
  };

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'
    }`}>
      {/* CSS Styles   dengan dark mode */}
      <style>
        {`
          .speedometer-gradient {
            background: conic-gradient(
              from 0deg,
              #ef4444 0deg 60deg,
              #b44f07ff 60deg 120deg,
              #eab308 120deg 180deg,
              #22c55e 180deg 240deg,
              #050c9dff 240deg 300deg,
              #5d4691ff 300deg 360deg
            );
          }
          
          .pulse-ring {
            animation: pulse-ring 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
          }
          
          @keyframes pulse-ring {
            0% {
              transform: scale(0.33);
              opacity: 1;
            }
            80%, 100% {
              transform: scale(2.33);
              opacity: 0;
            }
          }
          
          .speed-bar {
            height: 4px;
            background: linear-gradient(90deg, #ef4444, #f97316, #eab308, #22c55e, #050c9dff);
            border-radius: 2px;
            overflow: hidden;
          }
          
          .speed-indicator {
            height: 100%;
            background: ${isDarkMode ? '#1E9B4C' : 'white'};
            border-radius: 2px;
            transition: width 0.3s ease;
          }
          
          .glass-card {
            background: ${isDarkMode ? 'rgba(31, 41, 55, 0.7)' : 'rgba(255, 255, 255, 0.8)'};
            backdrop-filter: blur(10px);
            border: 1px solid ${isDarkMode ? 'rgba(30, 155, 76, 0.3)' : 'rgba(30, 155, 76, 0.2)'};
          }
          
          .test-button {
            background: ${isDarkMode ? 
              'linear-gradient(135deg, #1E9B4C, #16a34a)' : 
              'linear-gradient(135deg, #1E9B4C, #16a34a)'
            };
            transition: all 0.3s ease;
          }
          
          .test-button:hover {
            background: ${isDarkMode ?
              'linear-gradient(135deg, #16a34a, #1E9B4C)' :
              'linear-gradient(135deg, #16a34a, #1E9B4C)'
            };
            transform: translateY(-2px);
            box-shadow: 0 10px 25px ${isDarkMode ? 
              'rgba(30, 155, 76, 0.3)' : 
              'rgba(30, 155, 76, 0.3)'
            };
          }
          
          .test-button:active {
            transform: scale(0.98);
          }

          .connection-warning {
            background: ${isDarkMode ? 
              'rgba(239, 68, 68, 0.1)' : 
              'rgba(239, 68, 68, 0.05)'
            };
            border: 1px solid ${isDarkMode ? 
              'rgba(239, 68, 68, 0.3)' : 
              'rgba(239, 68, 68, 0.2)'
            };
            border-radius: 12px;
            padding: 16px;
            margin-bottom: 20px;
          }
        `}
      </style>

      {/* Header */}
      <div className="pt-8 pb-4 text-center mt-20">
        <h1 className={`text-4xl font-bold bg-gradient-to-r ${
          isDarkMode ? 'from-green-400 to-[#1E9B4C]' : 'from-[#1E9B4C] to-green-600'
        } bg-clip-text text-transparent`}>
          Internet Speed Test
        </h1>
        <p className={`mt-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          Test your real internet connection speed
        </p>
        
        {/* Connection warning for better accuracy */}
        <div className="max-w-2xl mx-auto mt-4">
          <div className="connection-warning text-center">
            <p className={`text-sm ${
              isDarkMode ? 'text-red-300' : 'text-red-600'
            }`}>
              For accurate results: Close other apps using internet, use wired connection if possible, 
              and ensure stable network during the test.
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          
          {/* Main Speed Test Area */}
          <div className="lg:col-span-2">
            <SpeedTestArea 
              currentPhase={currentPhase}
              currentSpeed={currentSpeed}
              results={results}
              isActive={isActive}
              progress={progress}
              onStart={handleStartTest}
              onReset={resetTest}
            />
          </div>

          {/* Sidebar */}
          <Sidebar 
            serverInfo={serverInfo}
            setServerInfo={setServerInfo}
            testHistory={testHistory}
            showHistory={showHistory}
            setShowHistory={setShowHistory}
            results={results}
            currentPhase={currentPhase}
          />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SpeedTestPage;